module.exports = __webpack_public_path__ + "img/yakult-stamp-icon.9b37ae01.png";